<header class="py-3 border-bottom d-flex position-relative" [class.bg-primary]="!isSettingsLoaded"
  [class.settings-color]="isSettingsLoaded">
  <div class="d-flex justify-content-start align-items-center ps-4">
    <div class="border-end pe-2">
      <a href="#" class="d-flex align-items-center mb-0 mb-lg-0 link-dark text-decoration-none">
        <img src="assets/andritz/logo.svg" alt="Brand Logo" width="84" height="16" />
      </a>
      <p class="mb-0 ps-1 pe-2 text-white fs-6">{{ title | titlecase }}</p>

    </div>
  </div>
  @if (isNotError) {
  <ng-content select="[left-nav]"></ng-content>


  <div class="flex-grow-1 d-flex ms-3 flex-column align-items-stretch">

    <div class="font-color">
      @if(_simulationService.isSimulationMode) {
      <span>{{ 'APP.SIMULATION' | translate }}: </span>
      <span>{{_simulationService.simulationName}} - {{_simulationService.simulationModuleName}}</span>
      }
    </div>

  </div>

  <div class="position-absolute top-50 start-50 translate-middle">
     @if(!_headerSpinnerService.isLoading()){
      @if(_projectFeService.selectedProject && !_simulationService.isSimulationMode) {
        <div class="d-flex align-items-center ms-2 font-color">{{ 'APP.PROJECT' | translate }}:
          {{_projectFeService.selectedProject.crmNo}} </div>
      }
    }
    @else {
    <div class="spinner-border text-light" role="status">
      <span class="sr-only"></span>
    </div>
    }
  </div>

  @if(isElectron && isOnline){
  <button class="btn btn-light" (click)="onSync()">Sync</button>
  }

  @if(isModuleDeveloper && !isElectron) {
  <div class="d-flex align-items-center gap-2 font-color">
    <span>Prod</span>
    <div class="form-check form-switch m-0">
      <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault" #switchToggle
        [checked]="_simulationService.isSimulationMode"
        (change)="_simulationService.onSimulationToggleChange(switchToggle.checked)">
    </div>
    <span>Sim</span>
  </div>
  }

  <adf-unit-type-toggle class="d-flex align-items-center ms-2" [showLabel]="false" borderColor="white" [ngModel]="_unitService.current" (ngModelChange)="_unitService.setSystem($event)"></adf-unit-type-toggle>

  <div class="d-flex justify-content-end align-items-center gap-3 pe-3">
    <ng-content select="[right-nav]"></ng-content>
  </div>

  <div class="d-flex flex-nowrap border-start">
    <adf-expander />
  </div>

  } @else {
  <div class="flex-grow-1"></div>
  }

  <div class="d-flex justify-content-end align-items-center gap-3">
    <div class="border-start ps-3">
      <adf-user-menu [userDisplayName]="userName" (logout)="onLogout()" />
    </div>
  </div>
</header>